<template>
  <footer class="layout-footer mt-30">
    <div class="footer-container fc99">
      <div class="def-w f-b-c">
        <div class="row">
          <dl>
            <dt>联系我们</dt>
            <dd>地址：{{ site.address }}</dd>
            <dd>联系电话：{{ site.consultHotline }}</dd>
            <dd>e-mail：{{ site.email }}</dd>
          </dl>
          <dl>
            <dt>技术支持</dt>
            <dd>技术支持：江苏易交易信息科技有限公司</dd>
            <dd>
              地址：江苏省常州市钟楼区玉龙南路280号常州大数据产业园4号楼21层
            </dd>
            <dd>电话：{{ site.technicalHotline }}</dd>
          </dl>
        </div>
        <div class="wx-qrcode">
          <img :src="site.wechatLogo" :alt="site.name" />
          <p>关注微信公众号</p>
        </div>
      </div>
    </div>
    <div class="site-info fc99 flex-column-center">
      <p>
        Copyright 2022All Rights Reserved 版权所有©2022 连云港集团有限公司
        苏ICP备16005875号
      </p>
    </div>
  </footer>
</template>

<script>
import { mapGetters } from "vuex";
import {
  getConstantDic,
  INFO_TYPE_OPTIONS,
  PROJECT_TYPE_OPTIONS,
  SELECT_OPTION_CONFIG,
} from "@/utils/constant";
export default {
  name: "LayoutFooter",
  data() {
    return {
      projectTypeOpt: getConstantDic(PROJECT_TYPE_OPTIONS).filter(
        (item) =>
          item[SELECT_OPTION_CONFIG.CODE] !==
          PROJECT_TYPE_OPTIONS.ALL[SELECT_OPTION_CONFIG.CODE]
      ),
      infoTypeOpt: getConstantDic(INFO_TYPE_OPTIONS).filter(
        (item) =>
          item[SELECT_OPTION_CONFIG.CODE] !==
          INFO_TYPE_OPTIONS.ALL[SELECT_OPTION_CONFIG.CODE]
      ),
      SELECT_OPTION_CONFIG,
    };
  },
  computed: {
    ...mapGetters(["site", "allMenusTree"]),
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="scss">
.layout-footer {
  .footer-container {
    width: 100%;
    height: 320px;
    padding-top: 50px;
    background-color: #333;
    dl {
      min-width: 450px;
      padding-right: 20px;
      line-height: 36px;
      dt {
        color: #fff;
        font-size: 20px;
        font-weight: bold;
      }
      dd {
        font-size: 14px;
      }
    }
    .wx-qrcode {
      text-align: center;
      font-size: 14px;
      img {
        width: 100px;
        height: 100px;
      }
    }
  }
  .site-info {
    width: 100%;
    height: 40px;
    text-align: center;
    font-size: 12px;
    background: $--color-primary;
    color: #fff;
  }
}
</style>
